import React, { useState } from "react";
import ConfirmModal from "components/ConfirmModal";
import { Button } from "reactstrap";

const ConfirmDeleteButton = (props) => {
  const { onDelete, title = "", deleteMessage = "Esta seguro que desea eliminar el elemento seleccionado?" } = props;
  const [isOpen, setIsOpen] = useState(false);

  const onConfirm = (e) => {
    if (onDelete) {
      onDelete(e)
    }
  }

  const toogleModal = (e) => {
    setIsOpen(!isOpen);
  }

  const openModal = () => {
    setIsOpen(true);
  }

  return (
    <>
      <Button color="danger" onClick={openModal}>
        {props.children}
      </Button>
      <ConfirmModal
        toggle={toogleModal}
        isOpen={isOpen}
        title={title}
        onConfirm={onConfirm}
        primaryBtn="Eliminar"
        primaryBtnColor="danger"
        secondaryBtnColor="secondary"
      >
        {deleteMessage}
      </ConfirmModal>
    </>
  );

}

export default ConfirmDeleteButton;